import React, { useState, useContext, useMemo, Fragment, useEffect, useRef } from 'react'
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import { useAliveController } from 'react-activation'
import { Dropdown, message, ConfigProvider, Button, Modal, Badge } from 'antd'
import { CaretDownOutlined, SearchOutlined, CloseOutlined, UpOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import MainContext from '@/stores/stores'
import { useIntl } from 'react-intl'
import styles from './index.module.scss'
import LogoImg from './LogoImg'
import accountApi from '@/api/accountApi';
import VinInput from "@/components/VinInput"
import { strEncrypt, getDecryptParams, getDecryptParamsKey } from '@/utils/utils'
import orderApi from '@/api/orderApi';
import listApi from '@/api/listApi'
import ExportinOe from "@/components/ExportinOe";
import { enToCn } from '@/utils/china-geo-map';

const HeaderThree: React.FC<any> = (props) => {
  const token = localStorage.getItem("token") || ''
  const { headerInfo={} } = props
  const config = headerInfo.config ? headerInfo.config : {}
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get("params")
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, isWomala, host, colorPrimary, fontColorPrimary, canLang, isCst, distributorInfo, hasFreeVin  } = commonStore

  let domain = window.location.host

  const [longer, setLonger] = useState<boolean>(true)
  const [allNav, setAllNav] = useState<any[]>([])
  const [standardNav, setStandardNav] = useState<any[]>([])
  const [moreNav, setMoreNav] = useState<any[]>([])

  const [isMobile, setIsMobile] = useState<boolean>(false)

  const [centerItems, setCenterItems] = useState<any[]>([])
  const [vinInputKey, setVinInputKey] = useState<string>('')

  const [classImg, setClassImg] = useState<any>({})
  const [classList, setClassList] = useState<any[]>([])
  const [groupClass, setGroupClass] = useState<any>({})
  const [selClass, setSelClass] = useState<string>("")
  const [secondClass, setSecondClass] = useState<string>("")
  const [classShow, setClassShow] = useState<boolean>(false)
  const [hasSecondClass, setHasSecondClass] = useState<boolean>(false)

  const [parts_categories_zone, set_parts_categories_zone] = useState<any[]>([])

  const [selTags, setSelTags] = useState<string>('')
  const [selHeaderClass, setSelHeaderClass] = useState<string>('')

  const [merchantList, setMerchantList] = useState<any[]>([])
  const [merchantItem, setMerchantItem] = useState<any>({})

  const modalRef = useRef<any>(null);
  const buttonRef = useRef<any>(null);

  const istest: number = window.location.host.includes("webtest") || window.location.host.includes("localhost:300") ? 1 : 0

  const lang: any  = window.localStorage.getItem('lang')

  useEffect(() => {
    getSecondClass()
    getNavgation()
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
    if(token && (!localStorage.getItem('tourist_user'))) {
      getCartList()
      // getOeHistory()
    }
  }, [])
  useEffect(() => {
    if(commonStore.query_mode) {
      getMerchantList()
    }
  }, [commonStore.query_mode])
  useEffect(() => {
    let config = headerInfo.config ? headerInfo.config : {}
    let _parts_categories_zone = config.data ? config.data : []
    set_parts_categories_zone(_parts_categories_zone)
    if(params) {
      let paramsObj = getDecryptParams(params)
      let tags = paramsObj.tags ? paramsObj.tags : ''
      let index = parts_categories_zone.findIndex((ele: any) => {
        if(tags && ele.tags) {
          let _tags = ele.tags.map((el: any) => el.name)
          let _tags_msg = _tags.join(',')
          if(_tags_msg === tags) {
            return true
          }else {
            return false
          }
        }else {
          return false
        }
      })
      if(index !== -1) {
        let _parts_categories_zone_item = _parts_categories_zone[index]
        setSelHeaderClass(_parts_categories_zone_item.name)
      }
    }
  }, [headerInfo, isMobile, lang, params])

  useEffect(() => {
    const lang: any  = window.localStorage.getItem('lang')
    if(lang === 'zh' || lang === 'cht') {
      if(document.body.clientWidth <= 1420) {
        setLonger(false)
      }else if(document.body.clientWidth <= 1800) {
        if((standardNav.length + moreNav.length) <= 9) {
          setLonger(true)
        }else {
          setLonger(false)
        }
      }else {
        setLonger(true)
      }
    }else {
      if(document.body.clientWidth <= 1420) {
        setLonger(false)
      }else if(document.body.clientWidth <= 1800) {
        if((standardNav.length + moreNav.length) <= 9) {
          setLonger(true)
        }else {
          setLonger(false)
        }
      }else {
        setLonger(true)
      }
    }
    if((standardNav.length + moreNav.length) <= 6) {
      setLonger(true)
    }
    
  },[standardNav, moreNav])

  // 点击外部区域关闭弹窗的逻辑
  useEffect(() => {
    const handleClickOutside = (event: any) => {
    // 检查点击是否发生在弹窗或按钮之外
    if (
      modalRef.current && 
      !modalRef.current.contains(event.target) && 
      buttonRef.current && 
      !buttonRef.current.contains(event.target)
    ) {
      setClassShow(false);
    }
  };

  if (classShow && pathname !== '/home') {
    // 在捕获阶段添加事件监听，避免冒泡问题
    document.addEventListener('click', handleClickOutside, true);
  }

  return () => {
    document.removeEventListener('click', handleClickOutside, true);
  };
    
  }, [classShow]);

  useEffect(() => {
    let companyItems = commonStore.userInfo && commonStore.userInfo.is_repair_shop_admin ? [
      {
        key: '/mine/company',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/company')}>
            <i className="iconfont icon-a-Vector1 mr5"></i>
            {intl.formatMessage({ id: '公司管理' })}
          </div>
        )
      },
    ] : []
    const _items: any = commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? [
      {
        key: '/mine/aftersales',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/aftersales')}>
            <i className="iconfont icon-tuikuanshouhou mr5"></i>
            {intl.formatMessage({id: '退款/售后'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/reconciliation',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/reconciliation')}>
            <i className="iconfont icon-duizhangdan mr5"></i>
            {intl.formatMessage({id: '对账单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/copewith',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/copewith')}>
            <i className="iconfont icon-yingfudan mr5"></i>
            {intl.formatMessage({id: '应付单'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ] : [
      {
        key: '/mine/address',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/address')}>
            <i className="iconfont icon-dizhiguanli mr5"></i>
            {intl.formatMessage({id: '地址管理'})}
          </div>
        )
      },
      {
        key: '/mine/invoice',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/invoice')}>
            <i className="iconfont icon-fapiaotaitou mr5"></i>
            {intl.formatMessage({id: '发票抬头'})}
          </div>
        ),
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        key: '/mine/setting',
        label: (
          <div className="flex-s-c" onClick={() => toCenterUrl('/mine/setting')}>
            <i className="iconfont icon-shezhi mr5"></i>
            {intl.formatMessage({id: '设置'})}
          </div>
        )
      },
      {
        key: 'logout',
        label: (
          <div className="flex-s-c" onClick={logout}>
            <i className="iconfont icon-tuichudenglu1 mr5"></i>
            {intl.formatMessage({id: '退出登录'})}
          </div>
        )
      }
    ]
    setCenterItems(_items)
  }, [commonStore.userInfo, commonStore.distributorInfo])

  const merchantItems: any = useMemo(() => {
    let _items = merchantList.map((item: any) => {
      return {
        key: item.merchant_id,
        label: (
          <div 
            className="flex-s-c" 
            onClick={() => {
              setMerchantItem(item); 
              window.localStorage.setItem('stock-merchant-id', item.merchant_id)
              window.location.href = "/home"}
            }
          >
            {item.erp_company}
          </div>
        )
      }
    })
    return _items
  }, [merchantList])

  useEffect(() => {
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.vin) {
        setVinInputKey(paramsObj.vin)
      }else if(paramsObj.brand && !paramsObj.vin) {
        setVinInputKey(paramsObj.brand)
      }else if(paramsObj.en_plate) {
        setVinInputKey(paramsObj.en_plate)
      }else if(paramsObj.oeList) {
        setVinInputKey(paramsObj.oeList)
      }else {
        setVinInputKey('')
      }
    }else {
      setVinInputKey('')
    }
    // if((commonStore.pageType === '6' || commonStore.pageType === '7') && pathname === '/cjh') {
    if(pathname === '/cjh') {
      // setOeKeyword('')
      if(params) {
        let paramsObj = getDecryptParams(params)
        console.log("paramsObj666:", paramsObj)
        if(paramsObj.class) {
          let _classArr = paramsObj.class.split(',')
          let class1 = _classArr[0].replace(/\+/, "&")
          let class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
          setSelTags('')
          setSelHeaderClass('')
          setSelClass(class1)
          setSecondClass(class2)
        }else {
          setSelClass('')
          setSecondClass('')
        }
        if(paramsObj.tags) {
          setSelClass('')
          setSecondClass('')
          setSelTags(paramsObj.tags)
          if(parts_categories_zone.length) {
            let index = parts_categories_zone.findIndex((ele: any) => {
              if(paramsObj.tags && ele.tags) {
                let _tags = ele.tags.map((el: any) => el.name)
                let _tags_msg = _tags.join(',')
                if(_tags_msg === paramsObj.tags) {
                  return true
                }else {
                  return false
                }
              }else {
                return false
              }
            })
            if(index !== -1) {
              let _parts_categories_zone_item = parts_categories_zone[index]
              setSelHeaderClass(_parts_categories_zone_item.name)
            }
          }
        }else {
          setSelTags('')
          setSelHeaderClass('')
        }
      }else {
        setSelClass('')
        setSecondClass('')
        setSelTags('')
        setSelHeaderClass('')
      }
    }
    if(pathname === '/oe') {
      const search = window.location.search
      let _params = getDecryptParamsKey(search, 'params')
      let paramsObj = _params ? getDecryptParams(_params) : {oeList: '', class: ''}
      setSelClass('')
      setSecondClass('')
      setSelTags('')
      setSelHeaderClass('')
    }
  }, [pathname, params, parts_categories_zone])

  const priceUnit = useMemo(() => {
    let _unit: string = ''
    if(commonStore.currency_data) {
      if(commonStore.currency_data.unit) {
        _unit = commonStore.currency_data.unit
      }else if(commonStore.currency_data.code) {
        _unit = commonStore.currency_data.code + '  '
      }
    }
    return _unit ? _unit : ''
  }, [commonStore.currency_data])

  const getCityByIp = async () => {
    try {
      const res = await fetch('https://hackmyip.com/api/ip');
      const data = await res.json();
      let location = data.data && data.data.location ? data.data.location : {}
      console.log("getCityByIp location:", location)
      let latitude = location.latitude
      let longitude = location.longitude
      let city = location.city
      return city;
    } catch (e) {
      console.error('定位失败', e);
      return null;
    }
  }
  const getMerchantList = async () => {
    try {
      let city = await getCityByIp()
      console.log("city:", city)
      let res = await accountApi.getMerchantList()
      if(res.code === 1) {
        let _data = res.data ? res.data : []
        setMerchantList(_data)
        let stock_merchant_id = localStorage.getItem('stock-merchant-id') || ''
        if(!stock_merchant_id) {
          if(_data.length) {
            let cityCN = enToCn(city)
            console.log("cityCN:", cityCN)
            let index = _data.findIndex((ele: any) => ele.province_city.includes(cityCN))
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            localStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            localStorage.setItem('stock-merchant-id', '')
            setMerchantItem({})
          }
        }else {
          if(_data.length) {
            let index = _data.findIndex((ele: any) => ele.merchant_id === stock_merchant_id)
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            localStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            localStorage.setItem('stock-merchant-id', '')
            setMerchantItem({})
          }
        }
      }
    }catch(err) {
      localStorage.setItem('stock-merchant-id', '')
      setMerchantItem({})
    }
  }

  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }

  const getNavgation = () => {
    accountApi.getNavgationNew({ domain: host || domain }).then((res: any) => {
      if(res.code === 1) {
        let navData = res.data
        let _allNav: any[] = []
        let cjhIndex = navData.findIndex((ele: any) => ele.path === '/cjh')
        let cjhItem = cjhIndex > -1 ? navData[cjhIndex] : {}
        let oeIndex = navData.findIndex((ele: any) => ele.path === '/oe')
        let oeItem = oeIndex > -1 ? navData[oeIndex] : {}
        navData.forEach((ele: any) => {
          if((ele.path === '/vin' || ele.path === '/cjh' || ele.path === '/carsearch') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/cjh')
            if(index === -1) {
              _allNav.push({
                path: '/cjh',
                is_add: 0,
                is_check: 1,
                name: cjhItem.name ? cjhItem.name : intl.formatMessage({id: '车架号查询'}),
                icon: ''
              })
            }
          }else if((ele.path === '/code' || ele.path === '/oe') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/oe')
            if(index === -1) {
              _allNav.push({
                path: '/oe',
                is_add: 0,
                is_check: 1,
                name: oeItem.name ? oeItem.name : intl.formatMessage({id: '零件号查询'}),
                icon: 'icon-lingjianchaxun'
              })
            }
          }else if(ele.is_add && ele.is_check) {
            ele.path = `/morepage/${ele.code}`
            _allNav.push(ele)
          }else if(ele.is_check) {
            if(ele.path === '/epc') {
              ele.icon = 'icon-EPCchaxun'
            }else if(ele.path === '/enquery') {
              ele.icon = 'icon-fabuxunjia'
            }
            _allNav.push(ele)
          }
        })
        let _standardNav = _allNav.filter((item: any, index: number) => index === 0 || (!item.is_add && item.is_check && item.path !== '/engine'))
        let _moreNav = _allNav.filter((item: any, index: number) => {
          if(item.is_add && item.is_check && index !== 0) {
            item.path = `/morepage/${item.code}`
            return true
          }
        })
        let filterStdNav = _standardNav.filter((ele: any) => ele.path !== '/cjh' && ele.path !== '/oe')
        if(filterStdNav.length < 4) {
          let lastIndexLen = 4 - filterStdNav.length
          let otherStandardNav = _moreNav.slice(0, lastIndexLen)
          _standardNav = [..._standardNav, ...otherStandardNav]
          _moreNav = _moreNav.slice(lastIndexLen)
        }
        let _homeUrl = _allNav[0] && _allNav[0].path ? _allNav[0].path : ''
        // console.log("homeUrl:", _homeUrl)
        setCommonStore({
          type: 'homeUrl',
          value: _homeUrl
        })
        setAllNav(_allNav)
        setStandardNav(_standardNav)
        setMoreNav(_moreNav)
      }
    })
  }

  const getCartList = () => {
    orderApi.getCartList().then((res: any) => {
      if(res.code === 1) {
        let _data = res.data
        let length = 0
        let price = 0
        let goods_code_list: any = []
        Object.keys(_data).forEach((items: string) => {
          Object.keys(_data[items].goods_list).forEach((item: string) => {
            length += 1
            _data[items].goods_list[item].selected = true
            if(_data[items].goods_list[item].stock_type === 'epc'){
              const d = _data[items].goods_list[item].data
              const basic = d.basic
              const supportBuy = d.supportBuy
              if(basic && supportBuy){
                if(basic.pic && basic.pic.length){
                  _data[items].goods_list[item].images = basic.pic[0].pic
                }else {
                  _data[items].goods_list[item].images = d.detail.img || ''
                }
                _data[items].goods_list[item].part_name = basic.label
                _data[items].goods_list[item].quality_name = intl.formatMessage({id: '大库原厂'})
                _data[items].goods_list[item].quality_oe = supportBuy.pid
                if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                  _data[items].goods_list[item]['4s_price'] = supportBuy.DMS.price / 100
                }
                _data[items].goods_list[item].quality_price = supportBuy.DMS.purchase_price / 100
                if(supportBuy.DMS.purchase_price) {
                  price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                }
                
              }
            }else if(_data[items].goods_list[item].stock_type === 'yc'){
              const info = _data[items].goods_list[item].data
              _data[items].goods_list[item].images = info.img || info.detail.img || ''
              _data[items].goods_list[item].part_name = info.part_name
              _data[items].goods_list[item].quality_name = intl.formatMessage({id: '原厂'})
              _data[items].goods_list[item].quality_oe = info.oe
              if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                _data[items].goods_list[item]['4s_price'] = info.price_4s
              }
            }else {
              goods_code_list.push({
                code: item,
                goods_cst_id: _data[items].goods_list[item].goods_cst_id,
                brandCode: _data[items].goods_list[item].data ? _data[items].goods_list[item].data.brandcode : ''
              })
            }
            
          })
        })
        if(goods_code_list.length > 0) {
          listApi.getAllGoods({
            goods_codes: goods_code_list
          }).then((res1: any) => {
            if(res1.code === 1) {
              let _data1 = res1.data
              Object.keys(_data).forEach((items: string) => {
                Object.keys(_data[items].goods_list).forEach((item: string) => {
                  if(_data[items].goods_list[item].stock_type !== 'epc' && _data[items].goods_list[item].stock_type !== 'yc'){
                    try{
                      _data[items].goods_list[item] = {
                        ..._data[items].goods_list[item],
                        ..._data1[_data[items].goods_list[item].goods_cst_id][item]
                      }
                      if(_data[items].goods_list[item].quality_price) {
                        price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                      }
                    }catch(err) {
                      console.info(err)
                    }
                  }
                })
              })
            }
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          }).catch((err: any) => {
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          })
        }else {
          setCommonStore({
            type: 'cartPrice',
            value: parseFloat(price.toFixed(2))
          })
        }
        setCommonStore({
          type: 'cartNum',
          value: length 
        })
      }
    })
  }

  const getPartCateZone = () => {
    let domain = window.location.host
    const lang: any  = window.localStorage.getItem('lang')
    accountApi.getHomeDataThree({ 
      domain: host || domain,
      lang 
    }).then((res: any) => {
      setCommonStore({
        type: 'isGetFreeCjh',
        value: true
      })
      if(res.code === 1) {
        let _parts_categories_zone = res.data && res.data.parts_categories_zone ? res.data.parts_categories_zone : []
        set_parts_categories_zone(_parts_categories_zone)
        if(params) {
          let paramsObj = getDecryptParams(params)
          let tags = paramsObj.tags ? paramsObj.tags : ''
          let index = _parts_categories_zone.findIndex((ele: any) => tags && ele.config && ele.config.tags && ele.config.tags === tags)
          if(index !== -1) {
            let _parts_categories_zone_item = _parts_categories_zone[index]
            setSelHeaderClass(_parts_categories_zone_item.name)
          }
        }
        let dataVin = res.data && res.data.vin ? res.data.vin : []
        let contract2 = res.data && res.data.contract2 ? res.data.contract2 : {}
        if(lang) {
          let item = contract2[lang] ? contract2[lang] : {}
          setCommonStore({ value: item, type: 'webData' })
        }
        setCommonStore({ value: dataVin.length ? true : false, type: 'hasFreeVin'})
        setCommonStore({ value: res.data.name, type: 'siteName' })
        setCommonStore({
          value: dataVin,
          type: 'freeCjhList'
        })
        setCommonStore({
          value: res.data && res.data.epc_brands ? res.data.epc_brands : {},
          type: 'epc_barnds'
        })
      }
    })
  }

  const getSecondClass = () => {
    accountApi.getSecondClass({
      is_hide: 1
    }).then((res: any) => {
      if(res.code === 1) {
        let images_dict = res.data && res.data.images_dict ? res.data.images_dict : {}
        let standard_maingroup = res.data && res.data.standard_maingroup ? res.data.standard_maingroup : []
        setClassImg(images_dict)
        setClassList(standard_maingroup)
        if(Object.keys(res.data.standard_subgroup_name).length) setHasSecondClass(true)
        setGroupClass(res.data.standard_subgroup_name)
      }
    })
  }

  const toHome = () => {
    navigate('/home')
  }

  const toMobilePage = () => {
    localStorage.removeItem('preferDesktop')
    if(commonStore.mobile_page === '1') {
      window.location.href = origin.includes('localhost') ? 'http://localhost:3000/#/' : origin + '/h5_index.html#/'
    }else {
      window.location.href = origin.includes('localhost') ? 'http://localhost:3000/' : origin
    }
  }

  const setLang = (lang: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor") => {
    setSearchParams({})
    window.localStorage.setItem('lang', lang)
    window.location.href = "/home"
  }

  const langItems: any = [
    {
      key: 'zh',
      label: (
        <div className="flex-s-c" onClick={() => setLang('zh')}>
          中文
        </div>
      )
    },
    {
      key: 'en',
      label: (
        <div className="flex-s-c" onClick={() => setLang('en')}>
          English
        </div>
      )
    },
    {
      key: 'ru',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ru')}>
          Русский язык
        </div>
      )
    },
    {
      key: 'fra',
      label: (
        <div className="flex-s-c" onClick={() => setLang('fra')}>
          French
        </div>
      )
    },
    {
      key: 'cht',
      label: (
        <div className="flex-s-c" onClick={() => setLang('cht')}>
        中文-繁體
        </div>
      )
    },
    {
      key: 'tr',
      label: (
        <div className="flex-s-c" onClick={() => setLang('tr')}>
        Türkiye
        </div>
      )
    },
    {
      key: 'ara',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ara')}>
          بالعربية
        </div>
      )
    },
    {
      key: 'pt',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pt')}>
          Português
        </div>
      )
    },
    {
      key: 'vie',
      label: (
        <div className="flex-s-c" onClick={() => setLang('vie')}>
          Tiếng Việt
        </div>
      )
    },
    {
      key: 'kor',
      label: (
        <div className="flex-s-c" onClick={() => setLang('kor')}>
          한국어
        </div>
      )
    },
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.key))

  const logout = () => {
    accountApi.logout().then((res: any) => {
      if(res.code === 1) {
        localStorage.removeItem("token")
        localStorage.removeItem("ycid")
        localStorage.removeItem("openid")
        window.location.href = '/home'
      }
    })
  }

  const toCenterUrl = (url: string) => {
    navigate(url)
  }
  const openNew = () => {
		window.open("/merchant/order/list", "__blank")
	}

  const capitalizeFirstLetter = (string: string) => {
    if(localStorage.getItem('lang') === 'en' && string) {
      return string.split(' ').map((word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }else {
      return string
    }
  }

  const delSelClass = (e: any) => {
    e.stopPropagation()
    setSelClass('')
    setSecondClass('')
    try {
      clear()
    }catch(err: any) {
      
    }
    let params1 = searchParams.get('params')
    let paramsObj: any = {}
    if(params1) {
      paramsObj = getDecryptParams(params1)
    }
    paramsObj.class = ''
    let _searchParams = strEncrypt(paramsObj)
    if(pathname === '/cjh' || pathname === '/oe' || pathname === '/home') {
      setSearchParams({
        params: _searchParams
      })
    }
  }

  const gotoClass = (item: any) => {
    if(token) {
      if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
        message.warning(intl.formatMessage({ id: "暂无权限" }))
        return false
      }
      
      try {
        clear()
      }catch(err: any) {
        
      }
      let params1 = searchParams.get('params')
      let paramsObj: any = {}
      if(params1) {
        paramsObj = getDecryptParams(params1)
      }
      paramsObj.class = item.title
      if(paramsObj.tags) {
        setSelTags('')
        setSelHeaderClass('')
        delete paramsObj.tags
      }
      let _searchParams = strEncrypt(paramsObj)
      setTimeout(() => {
        // navigate(`/class?params=${strEncrypt({class: item.title})}`)
        navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
      },100)
    }else {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
    }
    setClassShow(false)
  }

  const toGo = (url: string) => {
    navigate(url)
  }

  const goMore = (item: any) => {
    navigate(item.path)
  }

  const goToUrl = (item: any) => {
    let is_must = item.is_must
    
    let url = item.path
    
    if(url) {
      try {
        clear()
      }catch(err: any) {
        
      }
      setTimeout(() => {
        if(window.location.host.includes("partsbond") && url === '/epc') {
          if(window.localStorage.getItem("lang") === 'ru') {
            window.open('https://ru.partsbond.com',"__blank")
          }else {
            window.open('https://partsbond.com',"__blank")
          }
        }else {
          if(url === '/enquery' || url.includes('/epc')) {
            if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
              navigate(url)
            }else {
              message.warning(intl.formatMessage({ id: "请先登录" }))
              toGo('/login')
            }
          }else {
            navigate(url)
          }
        }
      },100)
      return false
    }
  }

  const gotoTagClass = (item: any) => {
    if(token) {
      if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
        message.warning(intl.formatMessage({ id: "暂无权限" }))
        return false
      }
      try {
        clear()
      }catch(err: any) {
        
      }
      let params1 = searchParams.get('params')
      let paramsObj: any = {}
      if(params1) {
        paramsObj = getDecryptParams(params1)
      }
      let tags = item.tags ? item.tags : []
      let tagsName = tags.map((ele: any) => ele.name)
      let tagsNameStr = tagsName.join(',')
      if(tags) {
        setSelClass('')
        setSecondClass('')
        paramsObj.tags = tagsName.join(',')
      }
      if(paramsObj.class) {
        delete paramsObj.class
      }
      setSelHeaderClass(item.name)
      setSelTags(tagsNameStr)
      let _searchParams = strEncrypt(paramsObj)
      setTimeout(() => {
        // navigate(`/class?params=${strEncrypt({class: item.title})}`)
        navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
      },100)
    }else {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
    }
  }

  const showMore = useMemo<any>(() => {
    if(isWomala || moreNav.length) {
      return [
        {
          name: intl.formatMessage({ id: '更多' }),
          key: 'more'
        }
      ]
    }else {
      return []
    }
  },[moreNav])

  const moreArr: any = isWomala ? [
    {
      name: intl.formatMessage({ id: '关于我们' }),
      path: '/aboutus',
      code: 'about_us',
      icon: 'icon-guanyuwomen'
    },
    {
      name: intl.formatMessage({ id: '联系我们' }),
      path: '/contactus',
      code: 'contract_us',
      icon: 'icon-lianxiwomen'
    },
    {
      name: intl.formatMessage({ id: '疑问解答' }),
      path: '/doubt',
      code: 'faq',
      icon: 'icon-yiwenjieda'
    },
    {
      name: intl.formatMessage({ id: '购买流程' }),
      path: '/buypath',
      code: 'purchase_process',
      icon: ''
    },
  ]: moreNav

  let _nowItem = moreArr.filter((item: any) => item.path === pathname)[0]

  const linkArr = [
    ...standardNav,
    ...showMore
  ]
  const _linkArr = longer ? [
    ...allNav
  ] : linkArr
  return (
    <>
      <div className={styles['header']} style={{ height: 190, background: colorPrimary }}>
        <div className={styles['header-title'] + ' flex-c-c'}>
          {
            token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo']}>
              <LogoImg style={{maxWidth: config.logo_width, maxHeight: config.logo_height}} src={config.logo || ""}/>
            </div> : <div className={styles['header-logo']} onClick={toHome}>
              <img src={config.logo || ""} alt="" />
            </div>
          }
          <div className={styles['header-center'] + ' flex-s-c'}>
            {
              commonStore.query_mode ? <div className='flex-s-c mr30'>
                <span>{intl.formatMessage({id: '发货仓'})}：</span>
                <Dropdown menu={{items: merchantItems}}>
                  <div className='flex-s-c'>
                    <span>{merchantItem.erp_company}</span>
                    <i className="iconfont icon-down ml5" />
                  </div>
                </Dropdown>
              </div> : null
            }
            {
              isMobile ? <div className="flex-s-c mr30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={toMobilePage}>{intl.formatMessage({id: '手机版'})}</div> : null
            }
            <div className="flex-s-c" >
              <Dropdown menu={{ items: langItems }}>
                <div className={styles['lang'] + ' flex-s-c pointer'} style={{ color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}>
                  {/* <img style={{ height: 20, marginRight: 6 }} src={langItems.filter((item: any) => item.key === lang)[0]?.logo} /> */}
                  { lang === 'zh' ? '中文' 
                    : lang === 'en' ? 'English' 
                    : lang === 'ru' ? 'Русский язык' 
                    : lang === 'cht' ? '中文-繁體' 
                    : lang === 'tr' ? 'Türkiye' 
                    : lang === 'ara' ? 'بالعربية' 
                    : lang === 'pt' ? 'Português'
                    : lang === 'vie' ? 'Tiếng Việt'
                    : lang === 'fra' ? 'French'
                    : lang === 'kor' ? '한국어' : '中文' }
                </div>
              </Dropdown>
            </div>
            {
              token && (!localStorage.getItem('tourist_user')) ? <div className="flex-s-c ml30 pointer">
                <i className="iconfont icon-a-wo1 mr5" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}/>
                <Dropdown menu={{ items: centerItems.filter((it: any) => !isCst || !it.cstnot) }}>
                  <div className="flex-s-c" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                    {userInfo.wechat_nick || userInfo.phone}
                    <i className="iconfont icon-down ml5" />
                  </div>
                </Dropdown>
              </div> : <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/login')}>
                <i className="iconfont icon-a-wo1 mr5"/>
                {intl.formatMessage({ id: '登录/注册' })}
              </div>
            }
            {
              token && (!localStorage.getItem('tourist_user')) && commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? <div className="flex-s-c ml30 pointer" style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => toCenterUrl('/mine/order')}>
                <i className="iconfont icon-wodedingdan mr5" />
                {intl.formatMessage({id: '我的订单'})}
              </div> : null
            }
            {
              distributorInfo.status ? (
                <div className='flex-s-c'>
                  <div onClick={() => navigate("/mine/invitation")} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} className={styles['invitation-code'] + ' flex-s-c ml30 pointer'}>
                    <img className="mr5" style={{ width: 14 }} src="https://userimgs.007cst.com/20240716/ce96dba4187ca42b1b2cf076ba4eeaa4.png" />
                    {intl.formatMessage({ id: '邀请码' })}
                  </div>
                  {
                    userInfo.is_repair_shop_admin ? (
                      <div className={'pointer flex-s-c ml30'} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => openNew()}>
                        <i className="iconfont icon-a-Group21471 mr10"/>
                        {intl.formatMessage({ id: '商户后台' })}
                      </div>
                    ): null
                  }
                </div>
              ): null
            }
          </div>
        </div>
        <div className={styles['header-wrap']} style={{padding: '0 20px'}}>
          <div className='flex-s-c'>
            {
              classList.length ? <div className={styles['cate-boot']}>
                <div ref={buttonRef} className={styles['cate-btn'] + ' flex-b-c'} onClick={() => setClassShow(!classShow)}>
                  <span className={styles['cate-msg']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>{selClass ? capitalizeFirstLetter(selClass) : intl.formatMessage({id: '分类'})}{selClass && secondClass ? '-' : ''}{selClass && secondClass ? capitalizeFirstLetter(secondClass) : ''}</span>
                  <span className='flex-s-c'>
                    {
                      selClass ? <CloseOutlined style={{fontSize: 14, color: fontColorPrimary ? fontColorPrimary : '#ffffff', cursor: 'pointer', marginRight: lang === 'ara' ? 0 : 5, marginLeft: lang === 'ara' ? 5 : 0}} onClick={e => delSelClass(e)}/> : null
                    }
                    {
                      classShow ? <UpOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/> : <DownOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                    }
                  </span>
                </div>
                {
                  classShow ? <div ref={modalRef} className={styles['class-wrap'] + ' flex-s-c'}>
                    <div className={styles['class-list']} style={{minHeight: '285px'}}>
                      {
                        classList.map((item: any, index: number) => {
                          return (
                            <div  key={index}  className={styles['categories-tab'] + " pointer " + `${selClass === item ? styles['active'] : ''}`} onClick={() => {setSelClass(item);}}>
                              <div className={styles['categories-img']}>
                                <img src={classImg[item] ? classImg[item] : 'https://cdns.007vin.com/img/autorepair/cst/no_item.png'} alt="" />
                              </div>
                              <div>
                                <div className={styles['title']}>{capitalizeFirstLetter(item)}</div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                    {
                      hasSecondClass && selClass ? <div className={styles['second-wrap']} style={{height: `${classList.length * 36 + 10}px`, minHeight: '285px'}}>
                        <div onClick={() => gotoClass({title: selClass})} className={styles['categories-subtab'] + " pointer" + ` ${selClass && !secondClass ? styles['active'] : ''}`}>{intl.formatMessage({ id: '全部' })}</div>
                        {
                          (groupClass[selClass] || []).map((str: string, i: number) => {
                            return (
                              <div key={i} className={styles['categories-subtab'] + " pointer " + `${selClass && secondClass === str ? styles['active'] : ''}`} onClick={() => gotoClass({ title: selClass + ',' + str })}>{capitalizeFirstLetter(str)}</div>
                            )
                          })
                        }
                      </div> : null
                    }
                  </div> : null
                }
              </div> : null
            }
            <div style={{position: 'relative'}} className={styles['header-input-6']}>
              <ConfigProvider
                theme={{
                  components: {
                    Input: {
                      /* 这里是你的组件 token */
                      activeBg: '#ffffff',
                      activeBorderColor: '#ffffff',
                      hoverBg: '#ffffff',
                      hoverBorderColor: '#ffffff'
                    },
                  },
                  token: {
                    /* 这里是你的全局 token */
                    colorBorder: 'rgba(255, 255, 255, 0.8)',
                  },
                }}
              >
                <VinInput
                  placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '车架号/品牌名称/OE/编码/零件名称'}) : intl.formatMessage({id: '搜索'})}
                  size="large"
                  width={750}
                  wrapStyle={{marginRight: 10, marginLeft: 10}}
                  style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: 'rgba(255, 255, 255, 0.8)', borderRadius: 6}}
                  classNames={{
                    input: hasFreeVin ? styles['page-input'] : styles['page-input-2']
                  }}
                  value={vinInputKey}
                  cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                  enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: 'rgba(255, 255, 255, 0.8)'}}></Button>}
                  hasFreeVin={true}
                  canSearchOe={true}
                  freeVinButtonStyle={{right: lang === 'ara' ? 'unset' : '107px', left: lang === 'ara' ? '107px' : 'unset'}}
                />
              </ConfigProvider>
            </div>
            {
              token && config.exportin_oe_checked ? (
                <ExportinOe 
                  btnStyle={{ 
                    background: 'rgba(255, 255, 255, 0.8)', 
                    color: colorPrimary 
                  }} 
                  qStyle={{ color: '#fff' }}
                />
              ): null
            }
            {
              token && (!localStorage.getItem('tourist_user')) ? <div className={styles['cart-btn'] + ' flex-b-c'} onClick={() => toGo('/cart')}>
                <div className='flex-s-c'>
                  <Badge count={commonStore.cartNum}>
                    <i className="iconfont icon-a-gouwucheman2" style={{fontSize: 20, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
                  </Badge>
                  <span className={styles['cart-price']}>{priceUnit}{commonStore.cartPrice}</span>
                </div>
                <RightOutlined style={{fontSize: 12, color: fontColorPrimary ? fontColorPrimary : '#ffffff'}}/>
              </div> : null
            }
          </div>
          <div className={styles['link-nav'] + ' flex-s-c'}>
            {
              parts_categories_zone.length > 0 ? linkArr.map((link: any, index: any) => {
                if(link.key) {
                  let nowItem = moreArr.filter((item: any) => item.path === pathname)[0]
                  return (
                    <Fragment key={index}>
                      <Dropdown menu={{ 
                        items: moreArr.map((item: any) => {
                          return {
                            key: item.path,
                            label: <div className='flex-s-c' onClick={() => goMore(item)}>
                              <i className={'iconfont mr5 ' + item.icon}/>
                              {item.name}
                            </div>
                          }
                        }) 
                      }}
                      >
                        <div className={styles['link'] + ' ' + `${ nowItem ? styles['active'] : '' }`} key={index} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: nowItem ? '500' : '400'}}>
                          {
                            nowItem ? <i className={'iconfont mr5 ' + nowItem.icon}/> : <i className={'iconfont mr5 ' + link.icon}/>
                          }
                          {nowItem ? nowItem.name : link.name}
                          <CaretDownOutlined className="ml5" />
                        </div>
                      </Dropdown>
                    </Fragment>
                    
                  )
                }
                return (
                  <Fragment key={index}>
                    {
                      link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                        {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                      </div>
                    }
                  </Fragment>
                )
              }) : (
                (lang === 'zh' || lang === 'cht' || lang === 'en') ? <>
                  {
                    linkArr.map((link: any, index: any) => {
                      return (
                        link.key ? null : <Fragment key={index}>
                          {
                            link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                              {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                            </div>
                          }
                        </Fragment>
                      )
                    })
                  }
                  {
                    moreArr.length < 7 ? moreArr.map((link: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                            {link.name}
                          </div>
                        </Fragment>
                      )
                    }) : <Fragment>
                      {
                        moreArr.slice(0, 5).map((link: any, index: number) => {
                          return (
                            <Fragment key={index}>
                              <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                                {link.name}
                              </div>
                            </Fragment>
                          )
                        })
                      }
                      <Dropdown menu={{ 
                        items: moreArr.slice(5).map((item: any) => {
                          return {
                            key: item.path,
                            label: <div className='flex-s-c' onClick={() => goMore(item)}>
                              <i className={'iconfont mr5 ' + item.icon}/>
                              {item.name}
                            </div>
                          }
                        }) 
                      }}
                      >
                        <div className={styles['link'] + ' ' + `${ _nowItem ? styles['active'] : '' }`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: _nowItem ? '500' : '400'}}>
                          {
                            _nowItem ? <i className={'iconfont mr5 ' + _nowItem.icon}/> : null
                          }
                          {_nowItem ? _nowItem.name : intl.formatMessage({id: '更多'})}
                          <CaretDownOutlined className="ml5" />
                        </div>
                      </Dropdown>
                    </Fragment>
                  }
                </> : <>
                  {
                    linkArr.map((link: any, index: any) => {
                      return (
                        link.key ? null : <Fragment key={index}>
                          {
                            link.path === '/cjh' || link.path === '/oe' ? null : <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goToUrl(link)}>
                              {link.is_must ? <i className={`iconfont mr5 icon-a-shouye2`}/> : <i className={'iconfont mr5 ' + link.icon}/>}{link.name}
                            </div>
                          }
                        </Fragment>
                      )
                    })
                  }
                  {
                    moreArr.length < 4 ? moreArr.map((link: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                            {link.name}
                          </div>
                        </Fragment>
                      )
                    }) : <Fragment>
                      {
                        moreArr.slice(0, 2).map((link: any, index: number) => {
                          return (
                            <Fragment key={index}>
                              <div className={styles['link'] + " " + `${pathname.indexOf(link.path) === 0 ? styles['active'] : ''}`} style={{borderRight: 'none', color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname.indexOf(link.path) === 0 ? '500' : '400'}} key={index} onClick={() => goMore(link)}>
                                {link.name}
                              </div>
                            </Fragment>
                          )
                        })
                      }
                      <Dropdown menu={{ 
                        items: moreArr.slice(2).map((item: any) => {
                          return {
                            key: item.path,
                            label: <div className='flex-s-c' onClick={() => goMore(item)}>
                              <i className={'iconfont mr5 ' + item.icon}/>
                              {item.name}
                            </div>
                          }
                        }) 
                      }}
                      >
                        <div className={styles['link'] + ' ' + `${ _nowItem ? styles['active'] : '' }`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: _nowItem ? '500' : '400'}}>
                          {
                            _nowItem ? <i className={'iconfont mr5 ' + _nowItem.icon}/> : null
                          }
                          {_nowItem ? _nowItem.name : intl.formatMessage({id: '更多'})}
                          <CaretDownOutlined className="ml5" />
                        </div>
                      </Dropdown>
                    </Fragment>
                  }
                </>
              )
            }
            <span className={styles['link-vertical'] + ' mr30'}></span>
            {
              (lang === 'zh' || lang === 'cht' || lang === 'en') ? 
                (
                  parts_categories_zone.length < 7 ? parts_categories_zone.map((item: any, index: number) => {
                  return (
                    <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                      {capitalizeFirstLetter(item.name)}
                    </div>
                  )
                }) : <Fragment>
                  {
                    parts_categories_zone.slice(0, 5).map((item: any, index: number) => {
                      return (
                        <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                          {capitalizeFirstLetter(item.name)}
                        </div>
                      )
                    })
                  }
                  <Dropdown 
                    menu={{ 
                      items: parts_categories_zone.slice(5).map((item: any) => {
                        return {
                          key: item.path,
                          label: <div className='flex-s-c' onClick={() => gotoTagClass(item)}>
                            {capitalizeFirstLetter(item.name)}
                          </div>
                        }
                      }) 
                    }}
                  >
                    <div className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass ? '500' : '400'}}>
                      {pathname === '/cjh' && selHeaderClass ? capitalizeFirstLetter(selHeaderClass) : intl.formatMessage({id: '更多分类'})}
                      <CaretDownOutlined className="ml5" />
                    </div>
                  </Dropdown>
                </Fragment>
              ) : (
                parts_categories_zone.length < 4 ? parts_categories_zone.map((item: any, index: number) => {
                  let config = item.config ? item.config : {}
                  let img = config[lang] && config[lang].img ? config[lang].img : ''
                  return (
                    <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                      {capitalizeFirstLetter(item.name)}
                    </div>
                  )
                }) : <Fragment>
                  {
                    parts_categories_zone.slice(0, 2).map((item: any, index: number) => {
                      return (
                        <div  key={index} className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass === item.name ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass === item.name ? '500' : '400'}} onClick={() => gotoTagClass(item)}>
                          {capitalizeFirstLetter(item.name)}
                        </div>
                      )
                    })
                  }
                  <Dropdown 
                    menu={{ 
                      items: parts_categories_zone.slice(2).map((item: any) => {
                        return {
                          key: item.path,
                          label: <div className='flex-s-c' onClick={() => gotoTagClass(item)}>
                            {capitalizeFirstLetter(item.name)}
                          </div>
                        }
                      }) 
                    }}
                  >
                    <div className={styles['link'] + " " + `${pathname === '/cjh' && selHeaderClass ? styles['active'] : ''}`} style={{color: fontColorPrimary ? fontColorPrimary : 'rgba(255, 255, 255, 0.7)', fontWeight: pathname === '/cjh' && selHeaderClass ? '500' : '400'}}>
                      {pathname === '/cjh' && selHeaderClass ? capitalizeFirstLetter(selHeaderClass) : intl.formatMessage({id: '更多分类'})}
                      <CaretDownOutlined className="ml5" />
                    </div>
                  </Dropdown>
                </Fragment>
              )
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderThree